<!-- The cart's tip card, moved. "No tip" is pre-selected: a tip is something the guest
     chooses, never something they have to notice and undo. The amount shown comes from the
     server, which works it out from the items after any discount. -->
<div class="tip-card">
  <div class="tip-header">
    <span class="tip-badge" aria-hidden="true">♥</span>
    <span class="tip-title">{{ 'orderDetails.tip.label' | translate }}</span>
  </div>

  <div class="tip-divider"></div>

  <div class="tip-body">
    <div class="tip-options" role="radiogroup" [attr.aria-label]="'orderDetails.tip.label' | translate">
      <button type="button" class="tip-option" role="radio"
              [class.selected]="isSelected({ kind: 'none' })"
              [attr.aria-checked]="isSelected({ kind: 'none' })"
              [disabled]="disabled"
              (click)="select({ kind: 'none' })">
        {{ 'orderDetails.tip.none' | translate }}
      </button>
      <button type="button" class="tip-option" role="radio" *ngFor="let preset of settings.presets"
              [class.selected]="isSelected({ kind: 'percent', percent: preset })"
              [attr.aria-checked]="isSelected({ kind: 'percent', percent: preset })"
              [disabled]="disabled"
              (click)="select({ kind: 'percent', percent: preset })">
        {{ preset }}%
      </button>
      <button type="button" class="tip-option" role="radio" *ngIf="settings.allowCustom"
              [class.selected]="selected.kind === 'fixed' || customOpen"
              [attr.aria-checked]="selected.kind === 'fixed'"
              [disabled]="disabled"
              (click)="openCustom()">
        <ng-container *ngIf="selected.kind === 'fixed' && !customOpen; else customLabel">
          {{ selected.amount | number:'1.2-2' }} <span [innerHTML]="currencySymbol"></span>
        </ng-container>
        <ng-template #customLabel>{{ 'orderDetails.tip.custom' | translate }}</ng-template>
      </button>
    </div>

    <div class="tip-custom-row" *ngIf="customOpen">
      <div class="tip-input-wrap">
        <input type="text" inputmode="decimal" class="tip-input"
               [placeholder]="'orderDetails.tip.customPlaceholder' | translate"
               [(ngModel)]="customInput"
               [disabled]="disabled"
               (keyup.enter)="applyCustom()"
               autocomplete="off" />
      </div>
      <button type="button" class="tip-apply" [disabled]="disabled" (click)="applyCustom()">
        {{ 'orderDetails.tip.apply' | translate }}
      </button>
    </div>

    <p class="tip-error" *ngIf="errorKey">
      {{ 'orderDetails.tip.errors.' + errorKey | translate: { amount: maxLabel } }}
    </p>

    <!-- What Order will add, as the server priced it — the line the cart's Order button
         showed above the total. Only once the server has confirmed a tip. -->
    <p class="tip-confirmed" *ngIf="amount > 0">
      {{ 'orderDetails.tip.label' | translate }}
      +{{ amount | number:'1.2-2' }} <span [innerHTML]="currencySymbol"></span>
    </p>
  </div>
</div>
